import { render, staticRenderFns } from "./AddCulvertInspection.vue?vue&type=template&id=380a1d94&scoped=true"
import script from "./AddCulvertInspection.vue?vue&type=script&lang=ts"
export * from "./AddCulvertInspection.vue?vue&type=script&lang=ts"
import style0 from "./AddCulvertInspection.vue?vue&type=style&index=0&id=380a1d94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380a1d94",
  null
  
)

export default component.exports